import React, { useContext, useRef, useState } from 'react';
import { SandBoxContext } from '../SandboxModal';
import TransactionEditor from '../../../views/AssetCatalog/Transactions/TransactionEditor/TransactionEditor';
import _ from 'lodash';
import { SandBoxTx, Transaction, TransactionWrapper } from '../../../types/rest/assetCatalogTypes';
import acApi from '../../../axios/ac/acApi';
import { updateTransactionAction } from '../../../store/transactions/transactionsActions';

import { useDispatch } from 'react-redux';
import { showToastNotification } from '../../../store/ui/toasts/toastsActions';
import { ToastType } from '../../../store/ui/toasts/toastsTypes';

const SandBoxTransaction = () => {
  const { state, setState } = useContext(SandBoxContext);
  const { sandboxTransaction } = state;
  const dispatch = useDispatch();

  const onChangeDefinition = useRef(
    _.debounce(async (transaction: Transaction) => {
      setState(prevState => {
        return {
          ...prevState,
          sandboxTransaction: {
            ...prevState.sandboxTransaction,
            dsl: transaction.dsl,
            sampleBody: transaction.sampleBody,
          } as SandBoxTx,
          isSandboxDirty: !_.isEqual(prevState.baseTransaction.dsl, transaction.dsl),
        };
      });

      const sandBoxTransaction = {
        transactionId: transaction.id,
        dsl: transaction.dsl,
        sampleBody: transaction.sampleBody,
      };

      try {
        await acApi.sandbox.updateSandbox(sandBoxTransaction);
      } catch (e) {
        dispatch(showToastNotification(ToastType.Danger, 'Cannot update Transaction'));
      }
    }, 500),
  );

  const updateTransactionFromSandBoxDefinition = () => {
    const txn = _.cloneDeep(state.baseTransaction);
    txn.dsl = sandboxTransaction.dsl;
    // Updating transaction.update field pass condition in transactionEditor
    // to update transactionState and user see changes on screen
    txn.updated = sandboxTransaction.updated;

    const transactionWrapper: TransactionWrapper = {
      transaction: txn,
      serviceId: sandboxTransaction.serviceId,
    };
    dispatch(updateTransactionAction(transactionWrapper));
    setState(prevState => ({
      ...prevState,
      isSandboxDirty: false,
    }));
  };

  return (
    <TransactionEditor
      transaction={sandboxTransaction}
      serviceId={sandboxTransaction.serviceId}
      onSave={transactionWrapper => onChangeDefinition.current(transactionWrapper.transaction)}
      isCreate={false}
      isReadOnly={false}
      onTabChanged={() => _.noop()}
      selectedEditorTab={'request'}
      insideSandbox={true}
      updateTransactionFromSandbox={updateTransactionFromSandBoxDefinition}
    />
  );
};

export default SandBoxTransaction;
